import { gql } from 'apollo-angular';

export const CreateProjectWageRateLegacyMutation = gql`
  mutation createProjectWageRateLegacyMutation(
    $tenantId: UUID!
    $legacyProjectId: Int!
    $input: CreateWageRateAggregateInputModelInput!
  ) {
    createProjectWageRateLegacy(
      tenantId: $tenantId
      legacyProjectId: $legacyProjectId
      input: $input
    ) {
      errors {
        message
        extensions {
          attemptedValue
          errorCode
          propertyName
          severity
        }
      }
      data {
        constructionTypeId
        craftClassificationId
        createdBy
        createdDate
        expirationDate
        id
        issueDate
        jurisdictionLocationId
        modifiedBy
        modifiedDate
        ownerTenantId
        publicationDate
        wageDeterminationModificationId
        wageRateShiftTypeId
        wageRateStatusTypeId
        wageRateTypeId
        craftClassification {
          apprenticeLevel
          craftId
          createdBy
          createdDate
          id
          isApprenticeableCraft
          jurisdictionId
          modifiedBy
          modifiedDate
          name
          craft {
            createdBy
            createdDate
            id
            jurisdictionId
            modifiedBy
            modifiedDate
            name
          }
        }
        wageRate {
          baseFringeRate
          baseWageRate
          notes
          standardHoursDay
          totalDoubletimeRate
          totalHourlyRate
          totalOvertimeRate
          trainingRate
        }
      }
    }
  }
`;
